import { DataCache, ForeignKeyRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';

import { TopicCardsResponse, TopicCardViewModel, ApplicableTopicCardTemplate } from 'data/models/TopicCardsResponse';

export class TopicCardsCache extends DataCache {
    TopicCardsResponses = PCCollection(TopicCardsResponse);
    TopicCardViewModels = PCCollection(TopicCardViewModel);
    ApplicableTopicCardTemplates = PCCollection(ApplicableTopicCardTemplate);

    constructor(data : PCCache) {
        super();

        new ForeignKeyRelationship(this.TopicCardsResponses, this.TopicCardViewModels,          r => r.TopicCards,          null, c => c.PortCallId());
        new ForeignKeyRelationship(this.TopicCardsResponses, this.ApplicableTopicCardTemplates, r => r.ApplicableTemplates, null, t => t.PortCallId());
        new SharedKeyRelationship (this.TopicCardsResponses, data.PortCalls,  r => r.PortCall, null);
        new SharedKeyRelationship (this.TopicCardViewModels, data.TopicCards, vm => vm.Card,   null);
        new ForeignKeyRelationship(data.TopicCardTemplates, this.ApplicableTopicCardTemplates, null, t => t.Template, t => t.TemplateId());
        new ForeignKeyRelationship(data.Berths,             this.ApplicableTopicCardTemplates, null, t => t.Berth,    t => t.BerthId());
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/topiccards/cache.ts